// import React, { useContext } from 'react';
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import { Main } from "./pages";

import "./App.css";

function App() {
  return (
    <div className="app">
      <Router>
        <Switch>
          <Route path="/" exact component={Main} />

          <Redirect to="/" />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
